var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home-hero"},[_c('LiteHome'),_c('LiteCopy',{attrs:{"authState":_vm.authState}}),_c('LiteAnalyzer',{attrs:{"authState":_vm.authState}}),_c('LiteDescription')],1)}
var staticRenderFns = []

export { render, staticRenderFns }